import { Box, Skeleton } from "@chakra-ui/react";
import { useMemo } from "react";
import { useAddress } from "../hooks/address.hooks";
import TruncatedTooltipText from "./TruncatedTooltipText";

function Address({ id }: { id: number | string | null | undefined }) {
	const { data: address, isLoading } = useAddress(id);

	const text = useMemo(() => {
		if (!address) {
			return "";
		}

		return `${address.streetNumber ?? ""} ${address.streetName ?? ""}, ${address.city ?? ""} ${address.postalCode ?? ""}, ${address.country ?? ""}`.replace(
			/\s+/g,
			" ",
		);
	}, [address]);

	return (
		<Skeleton isLoaded={!isLoading}>
			{address ? (
				<Box>
					<TruncatedTooltipText text={text} />
				</Box>
			) : (
				<>---</>
			)}
		</Skeleton>
	);
}

export default Address;
